import { inWindow } from './cenv';
export function testPathMatch(key, matchExactly, location) {
    if (!inWindow())
        return false;
    const loc = location || window.location;
    const urlPath = loc.pathname
        .replace('/static/sirius-web/linghang', '')
        .replace('/static/sirius-web', '')
        .replace(/index\.html$/i, '');
    if (key === '/') {
        return urlPath === '/';
    }
    return matchExactly ? urlPath === key : urlPath.indexOf(key) >= 0;
}
